import React from 'react';
import { Timer } from 'lucide-react';
import { getStatusInfo, getLicenseStatus, formatCPF, formatCNPJ } from './adminHelpers';

export const StatusBadge = ({ status }) => {
  const { label, color, Icon } = getStatusInfo(status);
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-${color}-500/20 text-${color}-400 border border-${color}-500/30`}>
      <Icon className="w-3 h-3" />{label}
    </span>
  );
};

export const LicenseBadge = ({ order }) => {
  const info = getLicenseStatus(order);
  if (!info) return null;
  const expiresDate = new Date(order.license_expires_at).toLocaleDateString('pt-BR');
  return (
    <div className={`flex items-center gap-1.5 text-xs px-2 py-1 rounded-full border bg-${info.color}-500/10 border-${info.color}-500/30 text-${info.color}-400`}>
      <Timer className="w-3 h-3" />
      <span>{info.expired ? `EXPIRADA em ${expiresDate}` : `${info.label} — ${expiresDate}`}</span>
    </div>
  );
};

export { formatCPF, formatCNPJ };
